<template>
<div class="chapter">
<div class="inner_page">
<p class="P_p7"><span><span style=" font-size: 0.75em;">By </span><span style=" font-size: 0.92em;">M</span><span style=" font-size: 0.75em;">ARY</span><span style=" font-size: 0.92em;"> C</span><span style=" font-size: 0.75em;">ALMES</span></span></p>
<p class="P_p8"><span><span style=" font-size: 0.75em; text-decoration: underline !important;">N</span><span style=" font-size: 0.58em; text-decoration: underline !important;">OVELS</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">C</span><span style=" font-size: 0.58em;">HANGE</span><span style=" font-size: 0.75em;"> </span><span style=" font-size: 0.58em;">OF</span><span style=" font-size: 0.75em;"> H</span><span style=" font-size: 0.58em;">EART</span><span style=" font-size: 0.75em;"> S</span><span style=" font-size: 0.58em;">ERIES</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">Change of Heart • Trusted Bond • Honored Vow</span></span></p>
<p class="P_p8"><span><span style=" font-size: 0.75em;">Crucible of Fate</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">A Matter of Time Vol. 1 &amp; 2</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">Bulletproof • But For You</span></span></p>
<p class="P_p8"><span><span style=" font-size: 0.75em;">Parting Shot</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">Acrobat</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">The Guardian</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">Mine</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">Three Fates (anthology)</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">Timing</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">Warders Vol. 1 &amp; 2</span></span></p>
<p class="P_p9"><span><span style=" font-size: 0.75em; text-decoration: underline !important;">N</span><span style=" font-size: 0.58em; text-decoration: underline !important;">OVELLAS</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">After the Sunset</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">Again</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">Any Closer</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">Frog</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">Romanus</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">The Servant</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">Steamroller</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">Still</span></span></p>
<p class="P_p8"><span><span style=" font-size: 0.75em;">What Can Be</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">T</span><span style=" font-size: 0.58em;">HE</span><span style=" font-size: 0.75em;"> W</span><span style=" font-size: 0.58em;">ARDER</span><span style=" font-size: 0.75em;"> S</span><span style=" font-size: 0.58em;">ERIES</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">His Hearth • Tooth &amp; Nail • Heart in Hand</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.75em;">Sinnerman • Nexus • Cherish Your Name</span></span></p>
<p class="P_p9"><span><span style=" font-size: 0.92em;">Published by D</span><span style=" font-size: 0.75em;">REAMSPINNER</span><span style=" font-size: 0.92em;"> P</span><span style=" font-size: 0.75em;">RESS</span></span></p>
<p class="P_p0"><span><span style=" font-size: 0.92em;">http://www.dreamspinnerpress.com</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?12fd1a3e